const clubTeamHighlight = state => state.clubTeamHighlight

const clubTeamHighlights = state => state.clubTeamHighlights

const clubTeamHighlightLoading = state => state.clubTeamHighlightLoading

const clubTeamHighlightsLoading = state => state.clubTeamHighlightsLoading

const clubTeamHighlightsLimited = state => state.clubTeamHighlightsLimited

export default {
  clubTeamHighlight,
  clubTeamHighlights,
  clubTeamHighlightLoading,
  clubTeamHighlightsLoading,
  clubTeamHighlightsLimited,
}
